var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8TailwindCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    id: "\u0421\u043B\u043E\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.4057,
    y1: 579.6213,
    x2: 120.5964,
    y2: 579.6213,
    gradientTransform: "matrix(6.123234e-17 1 -1 6.123234e-17 604.126 -70.789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAABFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    markerStart: "none",
    markerEnd: "none",
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M20.355,41.457c-0.832-0.844-1.855-1.924-2.944-2.819 c-1.125-0.925-2.515-1.823-4.244-2.256c-0.331-0.081-0.66-0.151-0.987-0.205l-0.897-0.112l0.223-0.104 c1.501-0.615,3.311-0.953,5.495-0.953c6.172,0,8.831,2.691,11.643,5.547c0.852,0.863,1.88,1.936,2.993,2.836 c1.14,0.921,2.54,1.811,4.259,2.24c0.329,0.083,0.657,0.152,0.984,0.207l0.847,0.107l-0.233,0.108 c-1.5,0.613-3.311,0.951-5.492,0.951C25.829,47.002,23.169,44.313,20.355,41.457z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.9053,
    y1: 575.8717,
    x2: 116.096,
    y2: 575.8717,
    gradientTransform: "matrix(6.123234e-17 1 -1 6.123234e-17 615.375 -84.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAABFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    markerStart: "none",
    markerEnd: "none",
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M35.354,23.455c-0.832-0.844-1.855-1.924-2.944-2.819 c-1.125-0.925-2.515-1.823-4.244-2.256c-0.331-0.081-0.66-0.151-0.987-0.205l-0.897-0.112l0.223-0.104 c1.501-0.615,3.311-0.953,5.495-0.953c6.172,0,8.831,2.691,11.643,5.547c0.852,0.863,1.88,1.936,2.993,2.836 c1.14,0.921,2.54,1.811,4.259,2.24c0.329,0.083,0.657,0.152,0.984,0.207l0.847,0.107l-0.233,0.108 c-1.5,0.613-3.311,0.951-5.492,0.951C40.827,29.001,38.167,26.311,35.354,23.455z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.2893,
    y1: 585.2513,
    x2: 133.9281,
    y2: 585.2513,
    gradientTransform: "matrix(6.123234e-17 1 -1 6.123234e-17 609.752 -83.138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A6DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C822FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    markerStart: "none",
    markerEnd: "none",
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M17.509,44.261c-1.892-1.915-3.367-3.515-5.313-4.003 c-3.483-0.871-6.54,0.54-9.395,4.344c-0.651,0.867-2.032,0.208-1.769-0.843c2.108-8.431,7.496-12.756,15.969-12.756 c7.857,0,11.511,3.712,14.492,6.739c1.879,1.905,3.421,3.516,5.372,4.004c3.481,0.869,6.479-0.535,9.336-4.344 c0.651-0.867,2.032-0.208,1.769,0.843c-2.108,8.431-7.496,12.753-15.969,12.753C24.143,50.998,20.489,47.287,17.509,44.261z  M44.462,42.015l-0.472,0.34c-2.267,1.515-4.792,2.036-7.609,1.331c-2.615-0.653-4.579-2.781-6.313-4.54 c-2.897-2.943-6.053-6.143-13.067-6.143c-5.64,0-9.647,2.067-12.096,6.292l-0.376,0.712l0.503-0.359 c2.287-1.515,4.835-2.035,7.651-1.331c2.616,0.656,4.528,2.795,6.249,4.539c2.899,2.943,6.056,6.141,13.069,6.141 c5.639,0,9.647-2.064,12.096-6.288L44.462,42.015z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.2893,
    y1: 570.2527,
    x2: 133.9281,
    y2: 570.2527,
    gradientTransform: "matrix(6.123234e-17 1 -1 6.123234e-17 609.752 -83.138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A6DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C822FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    markerStart: "none",
    markerEnd: "none",
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M32.507,26.259c-1.892-1.915-3.367-3.515-5.313-4.003 c-3.483-0.871-6.54,0.54-9.395,4.344c-0.651,0.867-2.032,0.208-1.769-0.843c2.108-8.431,7.496-12.756,15.969-12.756 c7.857,0,11.511,3.712,14.492,6.739c1.879,1.905,3.421,3.516,5.372,4.004c3.481,0.869,6.479-0.535,9.336-4.344 c0.651-0.867,2.032-0.208,1.769,0.843c-2.108,8.431-7.496,12.753-15.969,12.753C39.142,32.997,35.487,29.286,32.507,26.259z  M59.461,24.014l-0.472,0.34c-2.267,1.515-4.792,2.036-7.609,1.331c-2.615-0.653-4.579-2.781-6.313-4.54 c-2.897-2.943-6.053-6.143-13.067-6.143c-5.64,0-9.647,2.067-12.096,6.292l-0.376,0.712l0.503-0.359 c2.287-1.515,4.835-2.035,7.651-1.331c2.616,0.656,4.528,2.795,6.249,4.539c2.899,2.943,6.056,6.141,13.069,6.141 c5.639,0,9.647-2.064,12.096-6.288L59.461,24.014z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TailwindCss);
export default __webpack_public_path__ + "static/media/icons8-tailwind-css.c06915f58bc3016f16373d07bd5d1133.svg";
export { ForwardRef as ReactComponent };